import {
  ApplicationInsights,
} from "@microsoft/applicationinsights-web";
import { globalStore } from "@/store/modules/GlobalStore";
import router from "@/router";
import { BaseService } from "./BaseService";

class AIService extends BaseService {
  async getKey(): Promise<string> {
    try {
      const results = await this.client.get<string>("/api/ai/getkey");
      return results.data;
    } catch {
      return "NO_KEY";
    }
  }
}

class ExpressAppApplicationInsights {
  _instance: ApplicationInsights | null = null;

  async initialize(): Promise<void> {
    if (!this._instance) {
      const service = new AIService();
      const instrumentationKey = await service.getKey();
      console.log(`Instrumentation Key: ${instrumentationKey}`);
      this._instance = new ApplicationInsights({
        config: {
          instrumentationKey: instrumentationKey,
          /* ...Other Configuration Options... */
          enableUnhandledPromiseRejectionTracking: true,
          enableAjaxErrorStatusText: true,
        },
      });
      this._instance.loadAppInsights();
    }
  }

  getCustomProps(): { [key: string]: string } {
    return {
      version: globalStore.version,
      url: router.currentRoute.fullPath,
    };
  }

  pageView(page: string): void {
    if (this._instance) {
      const customProps = this.getCustomProps();
      this._instance.trackPageView({ name: page, properties: customProps });
    } else {
      throw new Error("Instance is not initialized");
    }
  }

  trace(message: string): void {
    if (this._instance) {
      const customProps = this.getCustomProps();
      this._instance.trackTrace({ message: message, properties: customProps });
    } else {
      throw new Error("Instance is not initialized");
    }
  }

  exception(err: Error): void {
    if (this._instance) {
      const customProps = this.getCustomProps();
      this._instance.trackException({
        exception: err,
        properties: customProps,
      });
    } else {
      throw new Error("Instance is not initialized");
    }
  }

  event(name: string): void {
    if (this._instance) {
      const customProps = this.getCustomProps();
      this._instance.trackEvent({ name: name, properties: customProps });
    } else {
      throw new Error("Instance is not initialized");
    }
  }
}

const AI = new ExpressAppApplicationInsights();

export default AI;
